import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Color } from '../../../styles/Color';
import { RouterLink } from '../link/RouterLink';
import {
	CardOrientation,
	ITheme,
	Responsive,
	StyledCard,
	isRelativeUrl,
} from '../../../ui';
import { hoverBoxShadow } from '../../../styles/animation/hoverBoxShadow';
import {
	HOVER_ZOOM_IMAGE_TRANSFORM,
	HOVER_ZOOM_IMAGE_TRANSITION,
} from '../../../styles/animation/hoverZoomImage';

interface IBaseCardProps {
	fullyClickable?: boolean;
	linkHref?: string;
	cardOrientation?: Responsive.IValueOrResponsiveValue<CardOrientation>;
	animationType?: 'boxShadow' | 'zoom';
	children: ReactNode;
}

export default function BaseCard({
	fullyClickable = true,
	linkHref,
	cardOrientation,
	animationType = 'zoom',
	children,
}: IBaseCardProps) {
	return fullyClickable && linkHref ? (
		<CardStyled
			fullyClickable={fullyClickable}
			cardOrientation={cardOrientation}
			animationType={animationType}
			className="no-max-width"
		>
			<StyledLink
				href={linkHref}
				target={!isRelativeUrl(linkHref) ? '_blank' : undefined}
			>
				<>{children}</>
			</StyledLink>
		</CardStyled>
	) : (
		<CardStyled
			fullyClickable={fullyClickable}
			cardOrientation={cardOrientation}
		>
			{children}
		</CardStyled>
	);
}

const StyledLink = styled(RouterLink)`
	text-decoration: none;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

const CardStyled = styled(StyledCard)<
	{
		fullyClickable: boolean;
		animationType?: IBaseCardProps['animationType'];
	},
	ITheme
>`
	flex-grow: 1;
	border-radius: ${(props) => props.theme.card?.borderRadius};
	margin-left: 0;
	position: relative;

	${({ fullyClickable, theme, animationType }) =>
		fullyClickable &&
		css`
			border: 1px solid ${Color.BorderCard};
			transition: ${HOVER_ZOOM_IMAGE_TRANSITION};

			&:hover {
				${animationType === 'boxShadow' && hoverBoxShadow(theme)}

				${animationType === 'zoom' &&
				`img {
					transform: ${HOVER_ZOOM_IMAGE_TRANSFORM};
				}`}

				

				h6 {
					color: ${theme.button?.secondary?.font?.color};
				}
			}
		`};
`;
